module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mainTitle":"Recommendations in physical activity","secondTitle":"Calculate my level of physical activity","child":"Child","adult":"Adult","senior":"Senior"},"fr":{"mainTitle":"Les recommandations en activité physique","secondTitle":"Les activités physiques adaptées proposées par l\u0027association","child":"Enfant","adult":"Adulte","senior":"Sénior"}}')
  delete Component.options._Ctor
}
